import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";

import "normalize.css/normalize.css";

import "./plugins/element";

import "./router/router";
import { hasPermission } from "@/utils/permission";

Vue.config.productionTip = false;
Vue.prototype.$hasPermission = function (moduleKey, actionKey = "view") {
  return hasPermission(this.$store.getters.permission, moduleKey, actionKey);
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
